// @generated by protoc-gen-es v2.12.0 with parameter "target=ts"
// @generated from file vision/membership/v1/resend_vision_invite.proto (package protos.vision.membership.v1, syntax proto3)
/* eslint-disable */

import type { GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file vision/membership/v1/resend_vision_invite.proto.
 */
export const file_vision_membership_v1_resend_vision_invite: GenFile = /*@__PURE__*/
  fileDesc("Ci92aXNpb24vbWVtYmVyc2hpcC92MS9yZXNlbmRfdmlzaW9uX2ludml0ZS5wcm90bxIbcHJvdG9zLnZpc2lvbi5tZW1iZXJzaGlwLnYxIpsBChlSZXNlbmRWaXNpb25JbnZpdGVSZXF1ZXN0Ek0KBnBhcmFtcxgBIAEoCzI9LnByb3Rvcy52aXNpb24ubWVtYmVyc2hpcC52MS5SZXNlbmRWaXNpb25JbnZpdGVSZXF1ZXN0LlBhcmFtcxovCgZQYXJhbXMSEgoKcHJvamVjdF9pZBgBIAEoCRIRCglpbnZpdGVfaWQYAiABKAkidgoaUmVzZW5kVmlzaW9uSW52aXRlUmVzcG9uc2USTgoGcmVzdWx0GAEgASgLMj4ucHJvdG9zLnZpc2lvbi5tZW1iZXJzaGlwLnYxLlJlc2VuZFZpc2lvbkludml0ZVJlc3BvbnNlLlJlc3VsdBoICgZSZXN1bHRiBnByb3RvMw");

/**
 * @generated from message protos.vision.membership.v1.ResendVisionInviteRequest
 */
export type ResendVisionInviteRequest = Message<"protos.vision.membership.v1.ResendVisionInviteRequest"> & {
  /**
   * @generated from field: protos.vision.membership.v1.ResendVisionInviteRequest.Params params = 1;
   */
  params?: ResendVisionInviteRequest_Params | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.ResendVisionInviteRequest.
 * Use `create(ResendVisionInviteRequestSchema)` to create a new message.
 */
export const ResendVisionInviteRequestSchema: GenMessage<ResendVisionInviteRequest> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_resend_vision_invite, 0);

/**
 * @generated from message protos.vision.membership.v1.ResendVisionInviteRequest.Params
 */
export type ResendVisionInviteRequest_Params = Message<"protos.vision.membership.v1.ResendVisionInviteRequest.Params"> & {
  /**
   * @generated from field: string project_id = 1;
   */
  projectId: string;

  /**
   * @generated from field: string invite_id = 2;
   */
  inviteId: string;
};

/**
 * Describes the message protos.vision.membership.v1.ResendVisionInviteRequest.Params.
 * Use `create(ResendVisionInviteRequest_ParamsSchema)` to create a new message.
 */
export const ResendVisionInviteRequest_ParamsSchema: GenMessage<ResendVisionInviteRequest_Params> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_resend_vision_invite, 0, 0);

/**
 * @generated from message protos.vision.membership.v1.ResendVisionInviteResponse
 */
export type ResendVisionInviteResponse = Message<"protos.vision.membership.v1.ResendVisionInviteResponse"> & {
  /**
   * @generated from field: protos.vision.membership.v1.ResendVisionInviteResponse.Result result = 1;
   */
  result?: ResendVisionInviteResponse_Result | undefined;
};

/**
 * Describes the message protos.vision.membership.v1.ResendVisionInviteResponse.
 * Use `create(ResendVisionInviteResponseSchema)` to create a new message.
 */
export const ResendVisionInviteResponseSchema: GenMessage<ResendVisionInviteResponse> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_resend_vision_invite, 1);

/**
 * @generated from message protos.vision.membership.v1.ResendVisionInviteResponse.Result
 */
export type ResendVisionInviteResponse_Result = Message<"protos.vision.membership.v1.ResendVisionInviteResponse.Result"> & {
};

/**
 * Describes the message protos.vision.membership.v1.ResendVisionInviteResponse.Result.
 * Use `create(ResendVisionInviteResponse_ResultSchema)` to create a new message.
 */
export const ResendVisionInviteResponse_ResultSchema: GenMessage<ResendVisionInviteResponse_Result> = /*@__PURE__*/
  messageDesc(file_vision_membership_v1_resend_vision_invite, 1, 0);

